<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        Website Visits
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/reporting"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove()"
        >
          Delete
        </button>
      </div>
    </div>
    <apexchart
      v-if="!loading && !error"
      :options="chartOptions"
      :series="series"
      height="300"
      type="area"
    />

    <div
      v-if="loading && !error"
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {
    widget: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      error: '',
      series: [{
        name: "Website Visits",
        data: []
      }],
      options: {
        colors: ['#0c9bef', '#969696'],
        xaxis: {
          categories: [],
          type: 'datetime',
        },
        tooltip: {
          x: {
            format: 'd MMM yyyy',
          }
        }
      }
    }
  },
  computed: {
    ...mapState('dashboard', [
      'activeWebsite',
      'chartBaseOptions',
      'trafficData',
      'preview',
      'trafficDataError',
    ]),
    ...mapState('user', ['user']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  watch: {
    trafficData: {
      handler() {
        if (this.activeWebsite.has_ga_connection) {
          if (this.trafficData?.specials?.linechart?.data?.data) {
            this.series[0].data = this.trafficData.specials.linechart.data.data;
            this.options.xaxis.categories = this.trafficData.specials.linechart.data.labels ?? [];
          }
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.error = `<i class="fa fa-btn fa-exclamation-triangle"></i> <span>Please connect to Google Analytics.</span><a href="/settings">Go to settings</a>`;
          this.loading = false;
        }
      },
      deep: true
    },
    trafficDataError: {
      handler() {
        if (this.trafficDataError) {
          this.error = `
                        <i class="fa fa-btn fa-exclamation-triangle"></i>
                        <span>There's a problem with your account connection. </span>
                        <a href="/website/settings/${this.activeWebsite.hash_id}">Go to settings</a>
                    `;
          this.loading = false;
        }
      }
    }
  },
  mounted() {
    if (this.activeWebsite.has_ga_connection) {
      if (this.trafficData?.specials?.linechart?.data) {
        this.series[0].data = this.trafficData.specials.linechart.data.data;
        this.options.xaxis.categories = this.trafficData.specials.linechart.data.labels ?? [];
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
    } else {
      this.error = `<i class="fa fa-btn fa-exclamation-triangle"></i> <span>Please connect to Google Analytics.</span> ${this.user ? `<a href="/website/settings/${this.user.active_website.hash_id}">Go to settings</a>` : ''}`;
      this.loading = false;
    }
  },
}
</script>
